export class SummaryConstants {
  public static NARRATIVE = 'narrative';
  public static REASONING = 'reasoning';

  public static UNKNOWN = 0;
  public static ASSET = 1;
  public static ALERT = 2;
  public static CVE = 3;
  public static INDICATOR_OF_RISK = 4;

  public static MISCONFIGURATION = 1;
  public static APPLICATION_VULNERABILITY = 2;
  public static OS_VULNERABILITY = 3;
  public static HUMAN_BASED = 4;

  public static ELEMENTS_GROUP = 'elements-group';

  public static OpenSidePanel = 'summary-open-side-panel';

  // singular because it s used like this in phrases.json
  public static ENUMERATION = 'enumeration';
  public static ALERTS = 'alerts';
  public static CVES = 'CVE';
  public static INDICATORS_OF_RISK = 'risk_indicator';

  public static NARRATIVE_DICTIONARY_CHAPTER = 'sentences';
  public static NARRATIVE_DICTIONARY_CHAPTER_WITHOUT_MATRIX = 'sentencesWithoutTranslationMatrix';
}
